import Vue from 'vue'
import Vuex from 'vuex'
import company from './company_class.js'
import axios from 'axios'
import session from './session.js'

Vue.use(Vuex)

export default new Vuex.Store({
    state:{
        company: new company(),
        fileslist: [],
        titles: null,
        example: null,
        uuid: null,
    },
    mutations:{
        UUID: (state, uuid) => state.uuid = uuid,
        FILESLIST: (state, fileslist) => state.fileslist = fileslist,
        COMPANY: (state, company) => state.company = company,
        TITLES: (state, titles) => state.titles = titles,
        EXAMPLE: (state, example) => state.example = example 
    },
    actions: {
        LOAD_FTE: context => { // F-Filelist, T-Titles, E-Example
            axios.get(`${window.$apiurl}/titles`).then(res => context.commit('TITLES', res.data.data))
            axios.get(`${window.$apiurl}/example`).then(res => context.commit('EXAMPLE', res.data.data))
            axios.get(`${window.$apiurl}/fileslist`).then(res => context.commit('FILESLIST', res.data.data))
        },
        SET_FILES: (context, files) => {
            let company = context.getters.COMPANY
            company.files = files
            context.dispatch('COMPANY', company)
        },
        SET_POINTS: (context, points) => {
            let company = context.getters.COMPANY
            company.points = points
            context.dispatch('COMPANY', company)
        },
        COMPANY: (context, company) => {
            context.commit('COMPANY', company)
        },
        SAVE_COMPANY: context => {
            let company = context.getters.COMPANY
            console.log(company)
        },
        REMEMBER_COMPANY: async (context) => {
            return await session.sendRequestToServer(
                context.getters.UUID,
                context.getters.COMPANY
            )
        }
    },
    getters:{
        UUID: state => state.uuid,
        FILESLIST: state => state.fileslist,
        COMPANY: state => state.company,
        TITLES:  state => state.titles,
        EXAMPLE: state => state.example
    }
})